import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDrips = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 103,
	height: 100,
	viewBox: "0 0 103 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					opacity: .97,
					d: "M63.5006 14.3995C72.5931 19.0665 83.6795 20.7817 90.3792 26.8846C97.0789 32.9476 99.3919 43.4382 99.3121 53.8491C99.2323 64.2998 96.7598 74.7106 91.8946 83.9647C87.0293 93.2188 79.8112 101.476 70.7985 99.7605C61.7858 98.1251 51.0584 86.5575 42.7236 82.4091C34.4288 78.2607 28.5267 81.4917 22.7442 81.2922C17.0415 81.0928 11.4983 77.4629 7.15146 72.3572C2.8844 67.1718 -0.186293 60.5902 2.28621 55.4047C4.7986 50.2192 12.9339 46.5096 15.6856 38.7713C18.5569 30.9931 15.9647 19.1462 19.195 11.0489C22.4252 3.03136 31.4378 -1.31647 39.3738 0.318953C47.3895 2.07404 54.4481 9.6927 63.5006 14.3995Z",
					fill: "#DFE9ED"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .97,
					d: "M72.992 16.4739C82.9219 19.4655 93.4101 25.9274 98.714 35.6601C104.098 45.3131 104.297 58.3167 100.947 70.6023C97.6771 82.9278 90.8977 94.6151 80.8083 97.0483C70.7986 99.4814 57.6385 92.7004 45.1962 91.6234C32.7539 90.5465 21.0694 95.1735 14.8881 91.5038C8.70684 87.8341 8.0289 75.7878 7.74974 65.7758C7.39083 55.7638 7.55035 47.7463 9.98297 40.5265C12.3757 33.3865 17.1213 27.0044 23.2228 22.7762C29.3243 18.5082 36.8216 16.4739 45.3159 15.1575C53.7304 13.8811 63.102 13.4822 72.992 16.4739Z",
					fill: "#DFE9ED"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M70.1605 35.9796H12.0566C10.4216 35.9796 9.10559 34.6633 9.10559 33.0279V15.7164C9.10559 14.081 10.4216 12.7646 12.0566 12.7646H70.2004C71.8354 12.7646 73.1514 14.081 73.1514 15.7164V33.0279C73.1116 34.6234 71.7955 35.9796 70.1605 35.9796Z",
					fill: "#F4F7F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M80.9678 61.548H22.8639C21.2289 61.548 19.9128 60.2317 19.9128 58.5963V41.2847C19.9128 39.6493 21.2289 38.333 22.8639 38.333H81.0076C82.6427 38.333 83.9587 39.6493 83.9587 41.2847V58.5963C83.9587 60.2317 82.6028 61.548 80.9678 61.548Z",
					fill: "#F4F7F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M90.9375 87.3556H32.7938C31.1587 87.3556 29.8427 86.0393 29.8427 84.4039V67.0924C29.8427 65.4569 31.1587 64.1406 32.7938 64.1406H90.9375C92.5726 64.1406 93.8886 65.4569 93.8886 67.0924V84.4039C93.8886 86.0393 92.5726 87.3556 90.9375 87.3556Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.2869 37.4951V50.9774H22.9038",
					stroke: "#5A7481",
					strokeWidth: 2,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeDasharray: "1 1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.8149 62.9844V76.4666H33.4717",
					stroke: "#5A7481",
					strokeWidth: 2,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeDasharray: "1 1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.3974 25.8483C19.2784 25.8483 19.9926 25.134 19.9926 24.2528C19.9926 23.3716 19.2784 22.6572 18.3974 22.6572C17.5164 22.6572 16.8022 23.3716 16.8022 24.2528C16.8022 25.134 17.5164 25.8483 18.3974 25.8483Z",
					fill: "#5A7481"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0572 25.8483C25.9382 25.8483 26.6524 25.134 26.6524 24.2528C26.6524 23.3716 25.9382 22.6572 25.0572 22.6572C24.1762 22.6572 23.462 23.3716 23.462 24.2528C23.462 25.134 24.1762 25.8483 25.0572 25.8483Z",
					fill: "#5A7481"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.398 25.8483C32.279 25.8483 32.9932 25.134 32.9932 24.2528C32.9932 23.3716 32.279 22.6572 31.398 22.6572C30.517 22.6572 29.8029 23.3716 29.8029 24.2528C29.8029 25.134 30.517 25.8483 31.398 25.8483Z",
					fill: "#5A7481"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M83.9587 57.6783C88.6279 57.6783 92.4131 53.8923 92.4131 49.222C92.4131 44.5517 88.6279 40.7656 83.9587 40.7656C79.2895 40.7656 75.5043 44.5517 75.5043 49.222C75.5043 53.8923 79.2895 57.6783 83.9587 57.6783Z",
					fill: "#94D1F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M83.7593 49.4619C83.52 49.4619 83.2808 49.5816 83.1212 49.7411H79.3726C79.0536 49.7411 78.7744 50.0203 78.7744 50.3395C78.7744 50.6586 79.0536 50.9378 79.3726 50.9378H83.1212C83.2808 51.0973 83.52 51.217 83.7593 51.217C84.2379 51.217 84.6367 50.8181 84.6367 50.3395C84.6367 49.8209 84.2379 49.4619 83.7593 49.4619Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M84.6366 50.6583C84.7961 50.419 84.836 50.1398 84.7563 49.8606L87.9466 44.715C88.146 44.3959 88.0263 43.9571 87.7073 43.7577C87.3883 43.5582 86.9496 43.6779 86.7502 43.997L83.5599 49.1426C83.2807 49.1825 83.0813 49.342 82.9218 49.5814C82.6427 50.06 82.7623 50.6583 83.2408 50.9376C83.7593 51.2965 84.3575 51.137 84.6366 50.6583Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M73.2711 32.0699C77.9403 32.0699 81.7254 28.2838 81.7254 23.6135C81.7254 18.9433 77.9403 15.1572 73.2711 15.1572C68.6019 15.1572 64.8167 18.9433 64.8167 23.6135C64.8167 28.2838 68.6019 32.0699 73.2711 32.0699Z",
					fill: "#A2F5E1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M70.5992 26.4456V20.8612C70.5992 20.5022 70.998 20.2629 71.317 20.4224L77.0995 23.4141C77.4584 23.6135 77.4584 24.1321 77.0596 24.2916L71.2771 26.8844C70.9581 27.0439 70.5992 26.8046 70.5992 26.4456Z",
					fill: "white"
				})
			]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 101.802,
			height: 100,
			fill: "white",
			transform: "translate(0.508057)"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 101.732,
			height: 100,
			fill: "white",
			transform: "translate(1.40894)"
		})
	})] })]
});
export default SvgDrips;
